import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { TextField, InputBase, Paper, Divider, Button, Hidden } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SearchIcon from '@mui/icons-material/Search';
import TablePaymentInvoice from '../components/DataTableUser/TablePaymentInvoice';
import { Grid } from '@mui/material'
const textFieldStyles = {
  '& fieldset': {
    borderRadius: 30,
  },
};

function SoInvoice() {
  const [invoiceList, setInvoiceList] = useState([]);
  const [startDate, setStartDate] = useState(
    null,
    // dayjs().startOf('month').format('YYYYMMDDHHmmss'),
  );
  const [endDate, setEndDate] = useState(
    null,
    // dayjs().format('YYYY-MM-DD')
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState({ direction: '', column: null });

  const getInvoiceList = async () => {
    const start =
      startDate === null ? '' : dayjs(startDate).format('YYYYMMDDHHmmss');
    const end =
      endDate === null
        ? ''
        : dayjs(endDate).endOf('day').format('YYYYMMDDHHmmss');
    const sortBy = sort.column ? `${sort.column}:${sort.direction}` : '';
    try {
      const path = `${
        process.env.REACT_APP_API_URL
      }/invoice/all-invoice-list?startDate=${start}&endDate=${end}&search=${search}&page=${
        page + 1
      }&size=${rowsPerPage}&sortBy=${sortBy}`;
      const { data } = await axios.get(path, {});
      setInvoiceList(data[0].data);
      const newTotal =
        data[0].metadata.length === 0 ? 0 : data[0].metadata[0].total;
      setTotal(newTotal);
    } catch (e) {
      throw new Error(e);
    }
  };
  const onClickSearch = () => {
    getInvoiceList();
  };
  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      getInvoiceList();
    }
  };
  useEffect(() => {
    getInvoiceList();
    return () => {};
  }, [rowsPerPage, page, sort]);

  return (
    <div className="">
      <div className="my-2 ml-2">
        <div className="text-lg font-light flex items-center justify-between">
          <div className=" text-xl">รายการรอชำระเงิน</div>
        </div>
        <div>
          <Hidden lgDown>
          <Grid container spacing={1}>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="วันที่"
                  value={startDate}
                  inputFormat="DD/MM/YYYY"
                  maxDate={endDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ ...textFieldStyles }}
                      size="small"
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {startDate === null || startDate === '' ? (
                  <DatePicker
                    disabled
                    label="ถึง"
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    minDate={startDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ ...textFieldStyles }}
                        {...params}
                      />
                    )}
                  />
                ) : (
                  <DatePicker
                    label="ถึง"
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    minDate={startDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ ...textFieldStyles }}
                        {...params}
                      />
                    )}
                  />
                )}
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Paper
                component="form"
                sx={{
                  pl: 2,
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '20px',
                  justifyContent: 'space-between',
                  boxShadow: 'none',
                  border: '1px solid #CCCCCC',
                }}
              >
                <InputBase
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  onKeyDown={handleKeyEnter}
                  placeholder="ค้นหา"
                />
                <div className="p-[8px]">
                  <SearchIcon
                    sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                  />
                </div>
              </Paper>
            </Grid>
            <Grid item xs={3} md={2} lg={1}>
              <div className="">
                <Button
                  variant="contained"
                  sx={{
                    background: 'primary',
                    color: 'white',
                    borderRadius: '20px',
                  }}
                  onClick={() => {
                    onClickSearch();
                  }}
                >
                  ค้นหา
                </Button>
              </div>
            </Grid>
          </Grid>
          </Hidden>
        </div>
      </div>
      <div className="mt-4">
        <TablePaymentInvoice
          invoiceList={invoiceList}
          rowsPerPage={rowsPerPage}
          page={page}
          total={total}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          startDate={startDate}
          endDate={endDate}
          sort={sort}
          setSort={setSort}
        />
      </div>
    </div>
  );
}

export default SoInvoice;